const ID_TOKEN_KEY = "token";
const USER_KEY = "currentUser";

export const getToken = () => window.localStorage.getItem(ID_TOKEN_KEY);
export const saveToken = (token) => window.localStorage.setItem(ID_TOKEN_KEY, token);
export const destroyToken = () => window.localStorage.removeItem(ID_TOKEN_KEY);

export const getUser = () => {
  const raw = window.localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};
export const saveUser = (user) =>
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
export const destroyUser = () => window.localStorage.removeItem(USER_KEY);

export default { getToken, saveToken, destroyToken, getUser, saveUser, destroyUser };
